<template>
  <div class="buget-wrap">
    <div class="table-wrap">
      <div class="filter">
        <el-input placeholder="请输入预算包名称" @change="changeKey" suffix-icon="el-icon-search" v-model="searchStr"> </el-input>
      </div>
      <div class="table">
        <el-table :max-height="tableHeight" ref="table" :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="预算包名称"> </el-table-column>
          <el-table-column prop="date" label="日期" width="180"> </el-table-column>
          <el-table-column prop="operate" label="操作" align="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewPkg(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="deletePkg(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <self-pagination
          class="footer-page"
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
    <el-dialog title="预算包详情" :visible.sync="dialogVisible" width="30%">
      <div v-if="modalDetail">
        <div class="field">
          <span class="field-label">预算包名称：</span>
          <span class="field-value">{{ modalDetail.name }}</span>
        </div>
        <div class="field">
          <span class="field-label">投放场景：</span>
          <span class="field-value">{{ (smart_bid_type_list.find((item) => item.value == modalDetail.smart_bid_type) || {}).label }}</span>
        </div>
        <div class="field" v-if="isBidCustom">
          <span class="field-label">竞价策略：</span>
          <span class="field-value">{{ modalDetail.flow_price === "stableCost" ? "稳定成本" : "控制成本上限" }}</span>
        </div>
        <div class="field" v-if="isBidCustom">
          <span class="field-label">投放速度：</span>
          <span class="field-value">{{ modalDetail.speed === "constantSpeed" ? "匀速" : "加速" }}</span>
        </div>
        <div class="field">
          <span class="field-label">预算：</span>
          <span class="field-value">{{ modalDetail.budget_mode === "BUDGET_MODE_DAY" ? "日预算" : "总预算" }}</span>
          <span class="field-value" style="margin-left: 12px">{{ modalDetail.budget }}CNY</span>
        </div>
        <div class="field">
          <span class="field-label">投放时间：</span>
          <span class="field-value">
            {{
              modalDetail.schedule_type === "SCHEDULE_FROM_NOW" ? "从今天到长期投放" : `${modalDetail.start_time} - ${modalDetail.end_time}`
            }}
          </span>
        </div>
        <div class="field">
          <span class="field-label">投放时间段：</span>
          <span class="field-value">
            {{ modalDetail.schedule_time && !modalDetail.schedule_time.includes("0") ? "不限" : "指定时间段" }}
          </span>
        </div>
        <div style="display: flex" class="field" v-if="modalDetail.schedule_time && modalDetail.schedule_time.includes('0')">
          <span class="field-label"></span>
          <div v-if="!modalDetail.schedule_time.includes('1')">展无投放时间段</div>
          <div v-else>
            <div v-if="day1.length > 0" class="field-value">星期一：{{ day1.join("，") }}</div>
            <div v-if="day2.length > 0" class="field-value">星期二：{{ day2.join("，") }}</div>
            <div v-if="day3.length > 0" class="field-value">星期三：{{ day3.join("，") }}</div>
            <div v-if="day4.length > 0" class="field-value">星期四：{{ day4.join("，") }}</div>
            <div v-if="day5.length > 0" class="field-value">星期五：{{ day5.join("，") }}</div>
            <div v-if="day6.length > 0" class="field-value">星期六：{{ day6.join("，") }}</div>
            <div v-if="day7.length > 0" class="field-value">星期日：{{ day7.join("，") }}</div>
          </div>
        </div>
        <div class="field" v-if="isBidCustom">
          <span class="field-label">付费方式：</span>
          <span class="field-value">
            {{ modalDetail.pricing === "OCPM" ? "按展示付费" : "" }}
          </span>
        </div>
        <div class="field" v-if="modalDetail.smart_bid_type !== 'SMART_BID_NO_BID'">
          <span class="field-label">出价模式：</span>
          <span class="field-value"> 固定出价 </span>
        </div>
        <div class="field" v-if="modalDetail.smart_bid_type !== 'SMART_BID_NO_BID'">
          <span class="field-label">目标转化出价：</span>
          <span class="field-value"> {{ modalDetail.cpa_bid }} CNY </span>
        </div>
        <div class="field" v-if="modalDetail.deep_bid_type !== 'DEEP_BID_DEFAULT'">
          <span class="field-label">深度优化方式：</span>
          <span class="field-value">
            {{ modalDetail.deep_bid_type === "DEEP_BID_PACING" ? "自动优化" : "自定义双出价" }}
          </span>
        </div>
        <div class="field" v-if="modalDetail.deep_bid_type === 'DEEP_BID_MIN'">
          <span class="field-label">深度出价模式：</span>
          <span class="field-value"> 固定出价 </span>
        </div>
        <div class="field" v-if="modalDetail.deep_bid_type === 'DEEP_BID_MIN'">
          <span class="field-label">深度转化出价：</span>
          <span class="field-value"> {{ modalDetail.deep_cpabid }} CNY </span>
        </div>
      </div>

      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBudget, delBudget } from "@/api/promotion.js";
import { smart_bid_type_list } from "@/pages/promotion/subPlan/subDirectpkg/optionData";
export default {
  data() {
    return {
      smart_bid_type_list,
      searchStr: "",
      tableHeight: window.innerHeight - 210,
      pageData: {
        total: 20,
        size: 10,
        page: 1,
      },
      tableData: [],
      dialogVisible: false,
      modalDetail: {},
      checkedValue: [],
      day1: [],
      day2: [],
      day3: [],
      day4: [],
      day5: [],
      day6: [],
      day7: [],
    };
  },

  computed: {
    isBidCustom() {
      return this.modalDetail.smart_bid_type === "SMART_BID_CUSTOM";
    },
  },

  watch: {
    $route: {
      handler(val) {
        if (val.name === "budget") {
          this.pageData.page = 1;
          this.getData();
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },

  methods: {
    showSelectNode(nodes) {
      this.checkedValue = nodes;
      let temp1 = [],
        temp2 = [],
        temp3 = [],
        temp4 = [],
        temp5 = [],
        temp6 = [],
        temp7 = [];
      calcTime(this.checkedValue.slice(0, 48)).map((item) => {
        temp1.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(48, 96)).map((item) => {
        temp2.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(96, 144)).map((item) => {
        temp3.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(144, 192)).map((item) => {
        temp4.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(192, 240)).map((item) => {
        temp5.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(240, 288)).map((item) => {
        temp6.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(288, 336)).map((item) => {
        temp7.push(formatStemp(item));
      });
      this.day1 = temp1;
      this.day2 = temp2;
      this.day3 = temp3;
      this.day4 = temp4;
      this.day5 = temp5;
      this.day6 = temp6;
      this.day7 = temp7;
    },
    changePage(page) {
      this.pageData.page = page;
      this.getData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getData();
    },
    changeKey() {
      this.pageData.page = 1;
      this.getData();
    },
    getData() {
      //查询预算包
      getBudget({
        name: this.searchStr,
        page: this.pageData.page,
        size: this.pageData.size,
      }).then((res) => {
        if (res.code === "0000") {
          this.pageData.total = res.count;
          this.tableData = res.budgetPrices.map((item) => {
            Object.assign(item, JSON.parse(item.data), {
              date: item.createDate,
            });
            return item;
          });
        }
      });
    },
    refresh() {
      this.tableHeight = window.innerHeight - 210;
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    deletePkg(data) {
      this.$confirm("确定删除该预算包?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delBudget({ id: data.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "预算包删除成功",
                type: "success",
              });
              this.pageData.page = 1;
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    viewPkg(data) {
      this.modalDetail = JSON.parse(data.data);
      console.log(this.modalDetail);
      this.showSelectNode(this.modalDetail.schedule_time.split("").map((item) => Number(item)));
      this.dialogVisible = true;
    },
  },
};
function calcTime(arr) {
  let newArr = [],
    temArr = [];
  for (let m = 0; m <= 48; m++) {
    if (arr[m]) {
      temArr.push((m + 1) * 30);
    } else {
      temArr.length && newArr.push(temArr);
      temArr = [];
      continue;
    }
  }
  return newArr;
}

function formatTime(time) {
  return `${String(time / 60).split(".")[0] < 10 ? `0${String(time / 60).split(".")[0]}` : String(time / 60).split(".")[0]}:${
    String(time / 60).split(".")[1] ? "30" : "00"
  }`;
}

function formatStemp(arr) {
  if (arr.length == 1) {
    return `${formatTime(arr[0] - 30)}~${formatTime(arr[0])}`;
  } else {
    return `${formatTime(arr[0] - 30)}~${formatTime(arr[arr.length - 1])}`;
  }
}
</script>

<style lang="less" scoped>
.buget-wrap {
  padding: 16px;
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .filter {
      width: 200px;
    }
    .table {
      margin-top: 20px;
      width: 100%;
    }
  }
  .field {
    margin-bottom: 8px;
    .field-label {
      width: 100px;
      display: inline-block;
      text-align: right;
    }
  }
}
</style>
